import http from 'axios'
import { camelizeKeys, decamelize } from 'humps'
import {
  selectFilter,
  selectOrder,
  selectPage,
  selectSort
} from '../reducers/studiesWithTranscriptsOrdered'

export const FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST =
  'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST'
export const FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED =
  'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED'
export const FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED =
  'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED'

export const CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER =
  'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER'
export const CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER =
  'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER'
export const CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE =
  'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE'
export const CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT =
  'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT'

const fetchRequest = () => ({
  type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST
})

const fetchSucceeded = data => ({
  type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED,
  data
})

const fetchError = error => ({
  type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED,
  error
})

export const changePage = page => dispatch => {
  dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE, page })

  return dispatch(fetchStudiesWithTranscriptsOrdered())
}

export const changeSort = (sort, order) => dispatch => {
  dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT, sort, order })

  return dispatch(fetchStudiesWithTranscriptsOrdered())
}

export const changeFilter = filter => dispatch => {
  dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER, filter })

  return dispatch(fetchStudiesWithTranscriptsOrdered())
}

export const fetchStudiesWithTranscriptsOrdered = () => (
  dispatch,
  getState
) => {
  dispatch(fetchRequest())

  const state = getState().studiesWithTranscriptsOrdered
  let sort = decamelize(selectSort(state))

  if (selectOrder(state) === 'desc') {
    sort = `-${sort}`
  }

  return http
    .get('/r/api/studies', {
      params: {
        include: 'project',
        'page[number]': selectPage(state),
        'filter[with_transcription]': true,
        'filter[without_videos]': true,
        'filter[study_or_project_name]': selectFilter(state),
        sort
      },
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${getAccessToken()}`
      }
    })
    .then(
      ({ data }) => dispatch(fetchSucceeded(camelizeKeys(data))),
      error => dispatch(fetchError(error))
    )
}

const getCookieValue = key =>
  document.cookie.replace(
    new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*=\\s*([^;]*).*$)|^.*$`),
    '$1'
  )

const getAccessToken = () => getCookieValue('fv_at')



// WEBPACK FOOTER //
// ../src/actions/studiesWithTranscriptsOrderedActions.js